import React from "react";
import PropTypes from "prop-types";

const MinusExpandIcon = ({ width = "20px" }) => (
  <div>
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      width={width}
    >
      <defs></defs>
      <path
        style={{ fill: "#505050", strokeWidth: "0px" }}
        d="M45.48-.24H3.81C1.51-.24-.35,1.63-.35,3.93v41.67c0,2.3,1.87,4.17,4.17,4.17h41.67c2.3,0,4.17-1.87,4.17-4.17V3.93c0-2.3-1.87-4.17-4.17-4.17ZM38.19,26.85H11.11c-1.15,0-2.08-.93-2.08-2.08s.93-2.08,2.08-2.08h27.08c1.15,0,2.08.93,2.08,2.08s-.93,2.08-2.08,2.08Z"
      />
    </svg>
  </div>
);

MinusExpandIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
};

export default MinusExpandIcon;
